import { ContextualContentBox, FoodsIcon, FormBox } from "@foodpilot/foods";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction, useState } from "react";
import { ProductInformation } from "./ProductInformation";
import { ProductFormType } from "../../ProductForm.types";
import { AgribalyseInfoDrawer } from "src/components/Drawer/AgribalyseInfo";

type Page1Props = {
    product: ProductFormType;
    setProduct: Dispatch<SetStateAction<ProductFormType>>;
    companyIds: { "@id": string; id: number; name: string };
};

export const Page1 = (props: Page1Props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack>
            <Stack flexDirection={"row"} alignItems={"center"} gap={theme.spacing(2)} padding={theme.spacing(2, 0)}>
                <FoodsIcon size={8} icon={"information"} />
                <Stack>
                    <Typography variant={"h1"}>{t("general_information")}</Typography>
                    <Typography variant={"body-regular"}>
                        {t(
                            "entity.ingredient_page.subtitle",
                            "Provide the ingredient information. Fields marked with an * are required to proceed.",
                        )}
                    </Typography>
                </Stack>
            </Stack>
            <Stack flexDirection="row" gap={theme.spacing(2)}>
                <Stack sx={{ flex: 3 }}>
                    <ProductInformation
                        product={props.product}
                        setProduct={props.setProduct}
                        companyIds={props.companyIds}
                    />
                </Stack>
                <FormBox
                    sx={{
                        position: "sticky",
                        top: "120px",
                        flex: 1.5,
                        padding: 0,
                    }}
                >
                    <AgribalyseBoxInfo />
                </FormBox>
            </Stack>
        </Stack>
    );
};

const AgribalyseBoxInfo = () => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    return (
        <Box>
            <ContextualContentBox size="small" title={t("pourquoi_associer_votre_produit_a_une_reference_agribalyse")}>
                <Box>
                    <Typography variant="body">{t("info.agribalyse_1")}</Typography>
                    <Button variant="text" onClick={() => setOpen(true)} endIcon={<ArrowForwardIcon />}>
                        {t("en_savoir_plus")}
                    </Button>
                </Box>
            </ContextualContentBox>
            <AgribalyseInfoDrawer isOpen={open} setOpen={setOpen} />
        </Box>
    );
};
